var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-button",
    {
      attrs: { icon: "el-icon-download", type: "primary" },
      on: { click: _vm.handleSubmit },
    },
    [_vm._v(" " + _vm._s(_vm.buttonText) + " ")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }